export const PasswordValidationCallbacks = [
  (v: string) =>
    v.length <= 0 || v.length >= 8 || "Password must be at least 8 characters long",
  (v: string) => {
    const errors = ["Password does not match the following criteria:"];

    if (!!v && !/[a-z]/.test(v)) {
      errors.push("At least 1 lowercase character.");
    }

    if (!!v && !/[A-Z]/.test(v)) {
      errors.push("At least 1 uppercase character.");
    }

    if (!!v && !/\d/.test(v)) {
      errors.push("At least 1 numeric character.");
    }

    if (!!v && !/[!@#$%^&*.,()[\]'<>=?]/.test(v)) {
      errors.push(
        "At least 1 special character (!@#$%^&*.,()[]'<>?=)."
      );
    }

    if (errors.length > 1) {
      return errors.join(" ");
    }

    return true;
  },

  (v: string) =>
    v.length <= 128 || "Password must be maximum 128 characters long",
];

export const RealNameValidationCallbacks = [
  (v: string) => {
    return !v.match(/^[\w \t.,_-]*$/) ? 'Forbidden characters found. Allowed characters are: [A-Z a-z 0-9 . , _ - SPACE]' : true;
  },
  (v: string) => !v || v.length >= 3 || 'Real Name is required to be at least 3 characters!',
];

const emailRegex = /^[A-Za-z0-9.-]{3,}@[A-Za-z0-9.-]{3,}\.[A-Za-z.-]{2,3}$/;

export const singleEmailValidation = (errorMessage: string = "Value must be a valid email address") => [
  (v: string) => {
    return v && emailRegex.test(v) || errorMessage;
  },
];

export const multipleEmailValidation = (errorMessage: string = "All the values must be valid email addresses") => [
  (v: string[]) => {
    if (!v || !v.length) {
      return true;
    }
    return v.every((v) => v && emailRegex.test(v)) || errorMessage;
  },
];
